module.exports = __webpack_public_path__ + "static/media/1.14cc08f0.jpg";